<template>
  <div class="navbar">
    <Platform id="hamburger-container" class="hamburger-container" />
    <!--    <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />-->
    <!--    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />-->
    <div class="right-menu">
      <!--           <template v-if="device!=='mobile'">-->

      <!--             <search id="header-search" class="right-menu-item" />-->

      <!--        <error-log class="errLog-container right-menu-item hover-effect" />-->

      <!--        <screenfull id="screenfull" class="right-menu-item hover-effect" />-->

      <!--        <el-tooltip content="Global Size" effect="dark" placement="bottom">-->
      <!--          <size-select id="size-select" class="right-menu-item hover-effect" />-->
      <!--        </el-tooltip>-->

      <!--      </template>-->
      <!-- <el-button type="primary" @click="createTiktok">发布抖音</el-button> -->
      <!-- <i class="el-icon-bell" /> -->

      <div class="pointer flex">
        <svg-icon icon-class="stLine-out-l" @click.native="logout" />
      </div>
    <!--  <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper">

          <img v-if="userInfo.platformAvatar" :src="userInfo.platformAvatar" class="user-avatar">
          <img v-else src="../../static/daoshi2.png" class="user-avatar">

          <i class="el-icon-caret-bottom" />
        </div> -->
      <!--  <el-dropdown-menu slot="dropdown" style="margin-top: -10px;width: 100px;">
          <el-dropdown-item @click.native="logout"> <span style="display:block;"> 退出 </span></el-dropdown-item>

        </el-dropdown-menu>
      </el-dropdown>-->
    </div>
  </div>
</template>

<script>
import { removeLocalStorage } from '@/utils/auth'

import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import ErrorLog from '@/components/ErrorLog'
import Screenfull from '@/components/Screenfull'
import SizeSelect from '@/components/SizeSelect'
import Search from '@/components/HeaderSearch'
import Platform from './platform/index'

export default {
  components: {
    Platform,
    Breadcrumb,
    Hamburger,
    ErrorLog,
    Screenfull,
    SizeSelect,
    Search
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'device'
    ]),
    userInfo() {
      return JSON.parse(JSON.parse(this.$store.state['zsm-user'].userInfo))
    }
  },
  data() {
    return {

    }
  },
  methods: {

    // 创建抖音
    createTiktok() {
      this.$router.push('/tiktok')
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    // async
    logout() {
      const that = this
      this.$confirm('退出知视猫创作者管理后台?', '提示', {
        confirmButtonText: '立即退出',
        cancelButtonText: '暂不退出',
        type: 'warning'
      }).then(() => {
        that.$store.dispatch('zsm-user/accountLogout', that.userInfo.mobile).then((res) => {
          that.$router.replace('/login')
          window.document.documentElement.setAttribute('data-theme', 'red')
        })
      }).catch(() => {

      })
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 48px;
  background-color: #fff;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  // -webkit-box-shadow: 0 6px 12px 0 rgb(18 38 63 / 5%);
  // box-shadow: 0 6px 12px 0 rgb(18 38 63 / 5%);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  /*z-index: 99;*/
  z-index: 99;
  overflow: hidden;

  // background-color: rgba(0, 0, 0, 0.79);
  background-color: #151515;
  .el-dropdown-menu{
    .el-dropdown-menu{
      top: 50px;
    }
    width:120px ;
  }
  /*box-shadow: 0 1px 4px rgba(0,21,41,.08);*/
  padding-right: 20px;
  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color:transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    /*float: right;*/
    height: 100%;
    line-height: 50px;
    button{
      width: 110px;
      margin-right: 40px;
      height: 35px;
      font-size: 12px;
    }
    svg{
      font-size: 24px;
      color:#fff;
    }
    .el-icon-bell{
      color:rgba(185, 183, 183, 100);
      font-size: 24px;
      margin-right: 40px;
    }
    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 7px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 50%;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
